import * as React from 'react';
import { NoWrapParagraph } from '../../components/cirium/NoWrapParagraph';
import { CiriumModal } from '../../components/cirium/CiriumModal';
import { Button, Flex } from '@flightstats/airframe-react';

export type MessageSentModalProps = {
  showModal: boolean,
  closeModal: () => void,
  title: string,
  contact: string,
};

export const MessageSentModal: React.FC<MessageSentModalProps> = ({
  showModal,
  closeModal,
  title,
  contact,
}) => (
  <CiriumModal showModal={showModal} closeModal={closeModal} title={title}>
    <Flex flexDirection="column" alignItems="center">
        <NoWrapParagraph textAlign="center">
          A test message was sent to
        </NoWrapParagraph>
        <NoWrapParagraph bold>{contact}</NoWrapParagraph>

        <Button mt="25px" onClick={closeModal}>
          OK
        </Button>
      </Flex>
  </CiriumModal>
);
